import { useContext } from "react";
import { APIContext } from "./APIProvider";

export const useAPI = () => {
  return useContext(APIContext);
};
